import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { GoalNameInputPropsShape } from "../../interfaces/componentTypes";
import { GoalUser, Goaltype } from "./generalUtilities";

export const GoalNameInput: React.FunctionComponent<GoalNameInputPropsShape> = ({
  handleGoalName,
  input,
  user,
  type,
  characterLimit,
}) => {
  const { t } = useContext(TMDataContext);
  return (
    <div className="goal-boxed-input-area">
      <div className="goal-form-input-row" style={{ marginBottom: "-10px" }}>
        <label className="goal-input-area-title" htmlFor="goal-title-input">
          {t("views.goals.headings.name")}
        </label>
        <div className="goal-title-input-wrap">
          <input
            type="text"
            className="goal-title-input-field"
            autoComplete="none"
            maxLength={characterLimit}
            onChange={handleGoalName}
            name="Goal Name:"
            value={input}
            id="goal-title-input"
          />
          <span
            className="goal-title-character-count"
            style={{ float: "right" }}
          >
            {input.length}/{characterLimit}
          </span>
        </div>
      </div>
      <GoalUser user={user} />
      <Goaltype type={type} />
    </div>
  );
};
